export const colors = {
  gymColors: [
    { name: "LoggedWorkouts", label: "Logged Workouts", color: "#ff4747" },
    { name: "LikesOnLoggedWorkouts", label: "Likes", color: "#4d83ff" },
    { name: "CommentsOnLoggedWorkouts", label: "Comments", color: "#71c016" },
  ],
  athleteColors: [
    { name: "LikesGiven", label: "Likes Given", color: "#7859df" },
    { name: "CommentsPosted", label: "Comments Posted", color: "#b6d820" },
    { name: "LoggedScores", label: "Logged Scores", color: "#ffc100" },
    { name: "LikesRecieved", label: "Likes Recieved", color: "#4d83ff" },
  ],
};
